var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRProblem1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.9972,
    height: 24,
    rx: 11.9986,
    fill: "#E54646"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7567 10.7453H11.1268L10.7578 12.4551H11.4777V13.1931H10.6048L10.2988 14.624H9.51587L9.82185 13.1931H8.83191L8.49894 14.75H7.71599L8.04896 13.1931H7.563V12.4551H8.21095L8.57993 10.7453H7.84198V10.0073H8.74192L9.0479 8.5764H9.83085L9.52487 10.0073H10.5058L10.8388 8.45041H11.6127L11.2798 10.0073H11.7567V10.7453ZM9.98384 12.4551L10.3438 10.7453H9.36288L8.9939 12.4551H9.98384ZM14.3078 14.75V10.5743H12.3459V9.91731C13.5158 9.87232 14.1908 9.30535 14.4158 8.45041H15.2167V14.75H14.3078Z",
    fill: "#E9FAE2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRProblem1);
export default __webpack_public_path__ + "static/media/r-problem1.d7ea4fc040b4a81c1f46fbf58b63bbc2.svg";
export { ForwardRef as ReactComponent };